import {
  CheckOutlined,
  LoadingOutlined,
  PlusCircleFilled,
  ReloadOutlined,
  SearchOutlined,
  ShoppingOutlined,
} from "@ant-design/icons";
import {
  Alert,
  Button,
  Card,
  Col,
  Collapse,
  Empty,
  Form,
  Grid,
  Input,
  message,
  Row,
  Select,
  Space,
  Spin,
  Tag,
  Typography,
} from "antd";
import { Content } from "antd/lib/layout/layout";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import cuentaAuxItems from "../../api/cuentaAux.json";
import {
  baseurlwc,
  credentials,
  GetAllCategorys,
  GetAllTermsAttributes,
} from "../../api/api";
import { baseurl } from "../../api/api";
import { GetTokenProducto, TypeIva } from "../../api/utils";

const { Option } = Select;
const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

const filterByChildren = (input, option) =>
  String(option.children).toLowerCase().indexOf(input.toLowerCase()) >= 0;

const sortByChildren = (a, b) =>
  String(a.children)
    .toLowerCase()
    .localeCompare(String(b.children).toLowerCase());

const ACCOUNTING_TYPES = [
  { name: "cat0", label: "Inventario", tipo: 0 },
  { name: "cat1", label: "Ventas", tipo: 1 },
  { name: "cat2", label: "Costo de Ventas", tipo: 2 },
  { name: "cat3", label: "Devolución Compras", tipo: 4 },
  { name: "cat4", label: "Devolución Ventas", tipo: 5 },
];

function fixEncoding(str = "") {
  return str.replace(/Ã\?/g, "Ñ");
}

export const AgregarVariacion = () => {
  const [searchResults, setSearchResults] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [productAttributes, setProductAttributes] = useState([]);
  const [attributeTerms, setAttributeTerms] = useState({});
  const [categorys, setCategorys] = useState([]);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [loadingAttributes, setLoadingAttributes] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [reloadingTerms, setReloadingTerms] = useState(false);
  const [accountingOpen, setAccountingOpen] = useState([]);
  const screens = useBreakpoint();
  const [form] = Form.useForm();

  toast.configure();

  useEffect(() => {
    GetAllCategorys()
      .then((res) => setCategorys(res.data || []))
      .catch(() => toast.error("Error al cargar categorías"));
  }, []);

  const searchProducts = useCallback(async (search) => {
    if (!search || search.trim().length < 2) {
      setSearchResults([]);
      return;
    }
    setLoadingSearch(true);
    try {
      const res = await axios.get(
        `${baseurlwc}/products?search=${encodeURIComponent(search.trim())}&type=variable&per_page=20&${credentials}`
      );
      setSearchResults(res.data || []);
    } catch (error) {
      toast.error(
        "Error al buscar productos: " +
          (error.response?.data?.message || error.message)
      );
    } finally {
      setLoadingSearch(false);
    }
  }, []);

  const selectProduct = async (productId) => {
    setLoadingAttributes(true);
    try {
      const res = await axios.get(
        `${baseurlwc}/products/${productId}?${credentials}`
      );
      const product = res.data;
      setSelectedProduct(product);

      const attrs = product.attributes || [];
      setProductAttributes(attrs);

      const termsMap = {};
      await Promise.all(
        attrs.map(async (attr) => {
          const termsRes = await GetAllTermsAttributes(attr.id, false);
          termsMap[attr.id] = termsRes.data || [];
        })
      );
      setAttributeTerms(termsMap);
    } catch (error) {
      toast.error(
        "Error al cargar el producto: " +
          (error.response?.data?.message || error.message)
      );
      setSelectedProduct(null);
    } finally {
      setLoadingAttributes(false);
    }
  };

  const changeProduct = () => {
    setSelectedProduct(null);
    setProductAttributes([]);
    setAttributeTerms({});
    setSearchResults([]);
    form.resetFields();
  };

  const reloadTerms = async () => {
    if (!selectedProduct) return;
    setReloadingTerms(true);
    try {
      const attrs = selectedProduct.attributes || [];
      const termsMap = {};
      await Promise.all(
        attrs.map(async (attr) => {
          const termsRes = await GetAllTermsAttributes(attr.id, true);
          termsMap[attr.id] = termsRes.data || [];
        })
      );
      setAttributeTerms(termsMap);
      toast.success("Términos actualizados correctamente");
    } catch (error) {
      toast.error(
        "Error al actualizar términos: " +
          (error.response?.data?.message || error.message)
      );
    } finally {
      setReloadingTerms(false);
    }
  };

  const onFinish = (values) => {
    if (!selectedProduct) return;

    const descTerms = productAttributes
      .map((attr) => values[`term-${attr.id}`])
      .filter(Boolean)
      .join("-");

    const productData = {
      TipoProducto: 1,
      IdIva: 0,
      Codigo: values.Codigo || "",
      Descripcion: `${selectedProduct.name}-${descTerms}`,
      IdCategoria: values.IdCategoria,
      IdSubCategoria: values.IdSubCategoria,
      Categoria: categorys.find((c) => c.id === values.IdCategoria)?.name || "",
      SubCategoria:
        categorys.find((c) => c.id === values.IdSubCategoria)?.name || "",
      PrecioVentaConIva1: values.PrecioVentaConIva1,
      PrecioVentaConIva2: values.PrecioVentaConIva1,
      PrecioVentaConIva3: values.PrecioVentaConIva1,
      PorcentajeIva: values.PorcentajeIva,
      weight: values.weight,
      dimensions: {
        length: values.length,
        width: values.width,
        height: values.height,
      },
      ParametrizacionContableProducto: ACCOUNTING_TYPES.map((t) => ({
        NumeroCuenta: values[t.name] || "",
        Tipo: t.tipo,
      })),
    };

    setLoadingSubmit(true);

    const getToken = GetTokenProducto(productData);
    toast.promise(getToken, {
      pending: "Obteniendo token de ARI...",
      success: "Token obtenido",
      error: "Error al obtener token de ARI",
    });

    getToken
      .then((tokenRes) => {
        if (!tokenRes?.data) {
          toast.error("No se pudo obtener el token de ARI");
          setLoadingSubmit(false);
          return Promise.reject(new Error("__no_token__"));
        }

        const productToSave = { ...productData, Token: tokenRes.data };

        toast.info("Guardando variación en ARI...", {
          position: "top-right",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        return axios.post(
          `${baseurl}GuardarProductoConContabilidad`,
          productToSave
        );
      })
      .then((ariRes) => {
        if (!ariRes) return Promise.reject(new Error("__no_ari__"));

        if (!ariRes.data.Exito) {
          toast.error("Error en ARI: " + ariRes.data.MensajeError);
          setLoadingSubmit(false);
          return Promise.reject(new Error("__ari_error__"));
        }

        toast.success("Variación guardada en ARI correctamente");

        // Actualizar atributos del producto padre para incluir el nuevo término
        const updatedAttributes = productAttributes.map((attr) => {
          const termName = values[`term-${attr.id}`];
          const currentOptions = attr.options || [];
          const newOptions = currentOptions.includes(termName)
            ? currentOptions
            : [...currentOptions, termName];
          return {
            id: attr.id,
            options: newOptions,
            visible: true,
            variation: true,
          };
        });

        const filteredAttributes = productAttributes
          .map((attr) => {
            const termName = values[`term-${attr.id}`];
            if (!termName) return null;
            const terms = attributeTerms[attr.id] || [];
            const termObj = terms.find((t) => t.name === termName);
            return {
              id: attr.id,
              option: termName,
              name: attr.name,
              slug:
                termObj?.slug || termName.toLowerCase().replace(/\s+/g, "-"),
            };
          })
          .filter(Boolean);

        const variationWC = {
          regular_price: `${values.PrecioVentaConIva1}`,
          price: values.PrecioVentaConIva1,
          manage_stock: true,
          weight: values.weight,
          dimensions: {
            length: values.length,
            width: values.width,
            height: values.height,
          },
          sku: ariRes.data.CodigoBarras,
          attributes: filteredAttributes,
          meta_data: [{ key: "referencia", value: values.Codigo || "" }],
        };

        toast.info("Actualizando atributos del producto padre...", {
          position: "top-right",
          autoClose: 6000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        // Primero actualizar atributos del padre (secuencial, no paralelo)
        // para que el término quede registrado antes de crear la variación
        return axios
          .put(
            `${baseurlwc}/products/${selectedProduct.id}?${credentials}`,
            { attributes: updatedAttributes }
          )
          .then(() => {
            toast.info("Creando variación en WooCommerce...", {
              position: "top-right",
              autoClose: 10000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            return axios.post(
              `${baseurlwc}/products/${selectedProduct.id}/variations?${credentials}`,
              variationWC
            );
          });
      })
      .then((wcVariationRes) => {
        if (!wcVariationRes) return;
        if (wcVariationRes.data.id) {
          toast.success("¡Variación creada correctamente en WooCommerce!", {
            position: "top-right",
            autoClose: 5000,
          });
        } else {
          toast.error(
            "Error al crear variación en WooCommerce: " +
              (wcVariationRes.data.message || "Error desconocido")
          );
        }
        setLoadingSubmit(false);
      })
      .catch((error) => {
        const internal = ["__no_token__", "__no_ari__", "__ari_error__"];
        if (!internal.includes(error.message)) {
          toast.error(
            "Error: " +
              (error.response?.data?.message || error.message)
          );
        }
        setLoadingSubmit(false);
      });
  };

  const handleFinalize = () => {
    setSelectedProduct(null);
    setSearchResults([]);
    setProductAttributes([]);
    setAttributeTerms({});
    setLoadingSubmit(false);
    form.resetFields();
  };

  const sectionCard = {
    marginBottom: 16,
    borderRadius: 12,
    background: "#fafbfc",
  };

  const selectSearchProps = {
    showSearch: true,
    allowClear: true,
    optionFilterProp: "children",
    filterOption: filterByChildren,
    filterSort: sortByChildren,
    style: { width: "100%" },
  };

  const handleFinishFailed = ({ errorFields }) => {
    message.info("Por favor complete todos los campos requeridos");
    if (errorFields.some((f) => String(f.name[0]).startsWith("cat"))) {
      setAccountingOpen(["accounting"]);
    }
  };

  return (
    <Content
      style={{
        marginTop: 20,
        overflow: "initial",
        padding: "0 16px 32px",
        marginLeft: screens.md ? 200 : 0,
      }}
    >
      <Row justify="center">
        <Card
          bordered={false}
          style={{
            borderRadius: 16,
            boxShadow: "0 8px 24px rgba(0, 0, 0, 0.1)",
            width: "100%",
            maxWidth: 1000,
          }}
          title="Agregar Variación a Producto Existente"
        >
          {/* BUSCAR PRODUCTO */}
          {!selectedProduct && !loadingAttributes && (
            <div style={{ padding: "8px 0 24px" }}>
              <Title level={5} style={{ marginBottom: 4 }}>
                Buscar producto variable
              </Title>
              <Text type="secondary">
                Escribe al menos 2 letras del nombre y selecciona el producto al
                que quieres agregarle una variación.
              </Text>
              <Select
                autoFocus
                size="large"
                showSearch
                style={{ width: "100%", marginTop: 16 }}
                placeholder="Ej: Camiseta Adidas"
                filterOption={false}
                onSearch={searchProducts}
                onChange={selectProduct}
                loading={loadingSearch}
                notFoundContent={
                  loadingSearch ? (
                    <Spin size="small" />
                  ) : (
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description="Escribe al menos 2 caracteres o no hay coincidencias"
                    />
                  )
                }
                suffixIcon={loadingSearch ? <LoadingOutlined /> : <SearchOutlined />}
              >
                {searchResults.map((product) => (
                  <Option key={product.id} value={product.id}>
                    <Space>
                      <ShoppingOutlined />
                      {product.name}
                      <Tag color="blue">ID: {product.id}</Tag>
                    </Space>
                  </Option>
                ))}
              </Select>
            </div>
          )}

          {/* CARGANDO ATRIBUTOS */}
          {loadingAttributes && (
            <div style={{ textAlign: "center", padding: 40 }}>
              <LoadingOutlined style={{ fontSize: 32, color: "#1890ff" }} />
              <p style={{ marginTop: 16, color: "#555" }}>
                Cargando datos del producto...
              </p>
            </div>
          )}

          {/* FORMULARIO */}
          {selectedProduct && !loadingAttributes && (
            <>
              <Alert
                type="info"
                showIcon
                icon={<ShoppingOutlined />}
                style={{ marginBottom: 24, borderRadius: 12 }}
                message={
                  <Space wrap>
                    <Text strong>{selectedProduct.name}</Text>
                    <Tag color="blue">ID: {selectedProduct.id}</Tag>
                  </Space>
                }
                description="Completa los datos de la nueva variación de este producto."
                action={
                  <Space direction="vertical" size={4}>
                    <Button
                      icon={<ReloadOutlined />}
                      loading={reloadingTerms}
                      onClick={reloadTerms}
                      size="small"
                    >
                      Actualizar términos
                    </Button>
                    <Button danger size="small" onClick={changeProduct}>
                      Cambiar producto
                    </Button>
                  </Space>
                }
              />

              <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                onFinishFailed={handleFinishFailed}
                autoComplete="off"
                initialValues={{
                  PorcentajeIva: "19%",
                  cat0: "143506",
                  cat1: "413506",
                  cat2: "613506",
                  cat3: "622505",
                  cat4: "417506",
                  IdCategoria: selectedProduct?.categories?.[0]?.id,
                  IdSubCategoria: selectedProduct?.categories?.[1]?.id,
                }}
              >
                {/* 1. INFORMACIÓN BÁSICA */}
                <Card
                  size="small"
                  bordered={false}
                  style={sectionCard}
                  title="1. Información básica"
                >
                  <Row gutter={16}>
                    <Col xs={24} lg={12}>
                      <Form.Item
                        label="Código de referencia"
                        name="Codigo"
                        tooltip="Código único para identificar esta variante (opcional)"
                      >
                        <Input placeholder="Único por variante" maxLength={45} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} lg={12} />
                    <Col xs={24} lg={12}>
                      <Form.Item
                        name="IdCategoria"
                        label="Categoría"
                        rules={[{ required: true, message: "Selecciona una categoría" }]}
                        tooltip="Categoría que se enviará a ARI"
                      >
                        <Select placeholder="Selecciona una categoría" {...selectSearchProps}>
                          {categorys.map((cat) => (
                            <Option key={cat.id} value={cat.id}>
                              {cat.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} lg={12}>
                      <Form.Item
                        name="IdSubCategoria"
                        label="Subcategoría"
                        rules={[{ required: true, message: "Selecciona una subcategoría" }]}
                        tooltip="Subcategoría que se enviará a ARI"
                      >
                        <Select placeholder="Selecciona una subcategoría" {...selectSearchProps}>
                          {categorys.map((cat) => (
                            <Option key={cat.id} value={cat.id}>
                              {cat.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>
                </Card>

                {/* 2. TÉRMINOS */}
                {productAttributes.length > 0 && (
                  <Card
                    size="small"
                    bordered={false}
                    style={sectionCard}
                    title="2. Términos de la variación"
                  >
                    <Row gutter={16}>
                      {productAttributes.map((attr) => (
                        <Col xs={24} lg={12} key={attr.id}>
                          <Form.Item
                            name={`term-${attr.id}`}
                            label={attr.name}
                            rules={[
                              {
                                required: true,
                                message: `Selecciona un término para ${attr.name}`,
                              },
                            ]}
                            tooltip={`Selecciona el término de ${attr.name} para esta variación`}
                          >
                            <Select placeholder={`Selecciona ${attr.name}`} {...selectSearchProps}>
                              {(attributeTerms[attr.id] || []).map((term) => (
                                <Option key={term.id} value={term.name}>
                                  {term.name}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                      ))}
                    </Row>
                  </Card>
                )}

                {/* 3. PRECIO, IVA Y MEDIDAS */}
                <Card
                  size="small"
                  bordered={false}
                  style={sectionCard}
                  title="3. Precio, impuestos y medidas"
                >
                  <Row gutter={16}>
                    <Col xs={24} lg={12}>
                      <Form.Item
                        label="Precio de venta (con IVA)"
                        name="PrecioVentaConIva1"
                        rules={[{ required: true, message: "Digite el precio de venta" }]}
                        tooltip="Precio de venta al público (incluye IVA)"
                      >
                        <Input addonBefore="$" placeholder="200000" type="number" min={0} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} lg={12}>
                      <Form.Item
                        name="PorcentajeIva"
                        label="Porcentaje IVA"
                        rules={[{ required: true, message: "Selecciona un porcentaje IVA" }]}
                        tooltip="Selecciona el porcentaje de IVA aplicable"
                      >
                        <Select
                          placeholder="Selecciona un porcentaje IVA"
                          allowClear
                          style={{ width: "100%" }}
                        >
                          {TypeIva.map((typeiva) => (
                            <Option key={typeiva.Codigo} value={typeiva.Valor}>
                              {typeiva.Descripcion}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={12} lg={6}>
                      <Form.Item
                        label="Peso"
                        name="weight"
                        rules={[{ required: true, message: "Digite el peso" }]}
                        tooltip="Peso del producto (ej: 1 kg, 0.3 kg)"
                      >
                        <Input placeholder="0.3" addonAfter="kg" />
                      </Form.Item>
                    </Col>
                    <Col xs={12} lg={6}>
                      <Form.Item
                        label="Largo"
                        name="length"
                        rules={[{ required: true, message: "Digite el largo" }]}
                      >
                        <Input placeholder="10" type="number" addonAfter="cm" />
                      </Form.Item>
                    </Col>
                    <Col xs={12} lg={6}>
                      <Form.Item
                        label="Ancho"
                        name="width"
                        rules={[{ required: true, message: "Digite el ancho" }]}
                      >
                        <Input placeholder="5" type="number" addonAfter="cm" />
                      </Form.Item>
                    </Col>
                    <Col xs={12} lg={6}>
                      <Form.Item
                        label="Alto"
                        name="height"
                        rules={[{ required: true, message: "Digite el alto" }]}
                      >
                        <Input placeholder="2" type="number" addonAfter="cm" />
                      </Form.Item>
                    </Col>
                  </Row>
                </Card>

                {/* 4. CONTABILIDAD (valores por defecto, colapsado) */}
                <Collapse
                  bordered={false}
                  activeKey={accountingOpen}
                  onChange={setAccountingOpen}
                  style={{ ...sectionCard, marginBottom: 0 }}
                >
                  <Collapse.Panel
                    key="accounting"
                    forceRender
                    header={
                      <Text strong>
                        4. Detalles contables{" "}
                        <Text type="secondary" style={{ fontWeight: 400 }}>
                          (cuentas por defecto, edita solo si es necesario)
                        </Text>
                      </Text>
                    }
                  >
                    <Row gutter={16}>
                      {ACCOUNTING_TYPES.map((item) => (
                        <Col key={item.name} xs={24} lg={12}>
                          <Form.Item
                            name={item.name}
                            label={`${item.tipo} - ${item.label}`}
                            rules={[
                              { required: true, message: "Selecciona una cuenta contable" },
                            ]}
                            tooltip={`Cuenta contable para ${item.label}.`}
                          >
                            <Select placeholder="Selecciona una cuenta" {...selectSearchProps}>
                              {cuentaAuxItems.map((cat) => (
                                <Option
                                  key={cat.SubCuentAuxiliarNumero}
                                  value={cat.SubCuentAuxiliarNumero}
                                >
                                  {`${cat.SubCuentAuxiliarNumero} - ${fixEncoding(
                                    cat.SubCuentaAuxiliarNombre
                                  )}`}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                      ))}
                    </Row>
                  </Collapse.Panel>
                </Collapse>

                {/* ACCIONES */}
                <div
                  style={{
                    position: "sticky",
                    bottom: 0,
                    zIndex: 5,
                    marginTop: 24,
                    padding: "12px 0",
                    background: "#fff",
                    borderTop: "1px solid #f0f0f0",
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 12,
                  }}
                >
                  <Button size="large" icon={<CheckOutlined />} onClick={handleFinalize}>
                    Finalizar
                  </Button>
                  <Button
                    type="primary"
                    htmlType="submit"
                    size="large"
                    icon={loadingSubmit ? <LoadingOutlined /> : <PlusCircleFilled />}
                    disabled={loadingSubmit}
                  >
                    {loadingSubmit ? "Creando variación..." : "Crear variación"}
                  </Button>
                </div>
              </Form>
            </>
          )}
        </Card>
      </Row>
    </Content>
  );
};

export default AgregarVariacion;
